<template>
  <PbDialog
    v-if="profile && report && translationsLoaded"
    :state="state"
    :loading="false /* loading */"
    :dialog-title="translate('pb2.reportDialog.title')"
    size="large"
    @open="open"
    @close="close"
  >
    <template #afterTitle>
      <ControlButton
        @click="toggle"
      >
        {{ translate(treeState ? 'pb2.reportDialog.collapseAll' : 'pb2.reportDialog.expandAll') }}
      </ControlButton>
    </template>
    <ReportMessage
      :item="{ report }"
      :default-state="treeState"
      :children-state="treeState"
    />
  </PbDialog>
</template>

<script setup>
import ControlButton from '@nicolaudie-group/ng-ui-kit/components/ControlButton/ControlButton.vue'

import useToggle from '@nicolaudie-group/ng-ui-kit/composables/useToggle'

import PbDialog from '@/components/PbDialog.vue'
import ReportMessage from '@/components/ReportMessage/ReportMessage.vue'
import { useReport, useProfile } from '@/composables/useProfile'
import useTranslate from '@/composables/useTranslate'
// import useTranslate from '@/composables/useTranslate'

defineProps({
  state: { type: Boolean, default: true },
})

const emit = defineEmits(['open', 'close'])

const { translate, translationsLoaded } = useTranslate()

const { state: treeState, toggle } = useToggle(true)

// const { translate } = useTranslate()

const report = useReport()
const profile = useProfile()

function close() {
  // When the close button or the overlay of the dialog is clicked or escape is pressed
  emit('close')
}

function open() {
  // When the dialog is opened
  emit('open')
}
</script>
